module.exports = __webpack_public_path__ + "application/templates/default/inner/movements/inner/list/list.template.html";